import { jsx as _jsx } from "react/jsx-runtime";
const SvgCsDeath = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4862 1.76621C9.55385 0.847241 8.11385 0 6 0C3.88615 0 2.44615 0.847241 1.51385 1.76621C0.512308 2.74793 0 4.09724 0 5.47793V6.72414C0 10.3103 2.76923 9.86207 2.76923 9.86207C2.76923 9.86207 2.76923 13 6 13C9.23077 13 9.23077 9.86207 9.23077 9.86207C9.23077 9.86207 12 10.3103 12 6.72414V5.47793C12 4.09724 11.4877 2.74793 10.4862 1.76621ZM4.61077 5.9531C4.51385 6.93931 3.81692 7.67897 3.05538 7.61172C2.29385 7.54 1.75385 6.68379 1.85077 5.69759C1.94769 4.71138 2.64462 3.97172 3.40615 4.03897C4.16769 4.11069 4.70769 4.9669 4.61077 5.9531ZM6.62308 9.86207H5.21077C4.94769 9.86207 4.78615 9.58414 4.92 9.36448L5.69077 8.11828C5.82923 7.88966 6.16615 7.88966 6.30923 8.11828L6.99231 9.22552C7.16769 9.50793 6.96 9.86207 6.62308 9.86207ZM8.94462 7.61172C8.18308 7.68345 7.48615 6.93931 7.38923 5.9531C7.29231 4.9669 7.83231 4.11069 8.59385 4.03897C9.35538 3.96724 10.0523 4.71138 10.1492 5.69759C10.2462 6.68379 9.70615 7.54448 8.94462 7.61172Z",
		fill: "currentColor"
	})
});
export default SvgCsDeath;
